import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getPlanSummaryCard } from 'constants/routes'

/**
 * Retrieves plan summary information from a given id.
 * @param {Object} planId - plan identifier to query.
 * @param {Object} communityId - community identifier to query.
 * @param {Object} marketId - market identifier to query.
 * @returns {Observable} - An observable that emits the plan summary information.
 */
const getPlanSummaryCardInformation = (planId, communityId, marketId) => {
  const params = new URLSearchParams();
  params.append('id', planId);

  if (communityId) {
    params.append('communityId', communityId);
  }

  if (marketId) {
    params.append('marketId', marketId);
  }

  const url = `${getPlanSummaryCard}?${params.toString()}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  }).pipe(
    switchMap((response) => response.json())
  );
};

export default getPlanSummaryCardInformation;